import { apiGetUserData } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import { setProfileUser } from "../../actionCreators/makeActionCreator";
// TODO move dublicate code into middleware
const LoadProfileInfoThunk = () => async (dispatch) => {
    try {
        const res = await apiGetUserData();
        dispatch(setProfileUser(res));
    }
    catch (error) {
        toastService.errorMessage(error);
    }
};
export default LoadProfileInfoThunk;
